(function() {
  
    let tlFreeGiftOfferClone;
    let embedWidgetClone ;
    
    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;
                val.showPopupOffer = (eligibleOtherRules) => {
                    const eligibleRules = eligibleOtherRules.filter(({rule}) => rule.widget ? rule.widget.popup : true);
                    if(eligibleRules.length){
                        const {POPUP_LAYOUT, POPUP_SESSION_STORAGE_KEY, MODULE} = window.tlFreeGiftOffer.constants;
                        if(window.tlFreeGiftOffer.popupWidget.layout == POPUP_LAYOUT.GIFTS_ONLY){
                            const sessionState = window.tlFreeGiftOffer.utils.getSessionStorage(POPUP_SESSION_STORAGE_KEY);

                            const eligibleRule = eligibleRules.find(({rule, bogoItem}) => {
                                const allowedShow = !(sessionState.dismissStatus?.[rule.id]) && !rule.auto_add_gift;
                                if(rule.module == MODULE.BOGO) return !!bogoItem && allowedShow;
                                return allowedShow
                            })
                            
                            if(eligibleRule) window.tlFreeGiftOffer.popupWidget.showOffer(eligibleRule)
                        }else {
                            // For detail popup list style: show modal if claim count increased for any rule
                            const { POPUP_SESSION_STORAGE_KEY } = window.tlFreeGiftOffer.constants;
                            const sessionState = window.tlFreeGiftOffer.getSessionState(POPUP_SESSION_STORAGE_KEY);
                            sessionState.ruleIdMetConditionTimesMap = sessionState.ruleIdMetConditionTimesMap ?? {}

                            window.tlFreeGiftOffer.popupWidget.showModal();

                            window.tlFreeGiftOffer.setSessionState(POPUP_SESSION_STORAGE_KEY, sessionState);
                        }
                    }
                }
            }
        },
        configurable: true
    });
})();